import { render, staticRenderFns } from "./NumCompare.vue?vue&type=template&id=002437aa"
import script from "./NumCompare.vue?vue&type=script&lang=js"
export * from "./NumCompare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports